export default __webpack_public_path__ + "static/media/tradeIcon.51ad9ba1.svg";